// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgErrorServer = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    data-name="Error 500"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="170 208 460 300"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.se-1 {
  stroke: #fff;
  stroke-width: 0.25px;
}
.se-1,
.se-2,
.se-3,
.se-4 {
  stroke-miterlimit: 10;
}
.se-5,
.se-3 {
  fill: #fff;
}
.se-6 {
  fill: #484747;
}
.se-7 {
  fill: #f39ee5;
}
.se-2,
.se-3 {
  stroke: #000;
  stroke-width: 0.5px;
}
.se-4 {
  fill: #ff49a4;
  font-family: Satoshi-Black, Satoshi;
  font-size: 225px;
  font-weight: 800;
  stroke: #f39ee5;
}
`}</style>
    </defs>
    <g>
      <circle className="se-7" cx={269.26} cy={263.43} r={1.37} />
      <circle className="se-7" cx={272.76} cy={264.26} r={1.37} />
      <circle className="se-7" cx={274.12} cy={267.54} r={1.37} />
      <circle className="se-7" cx={269.97} cy={267.59} r={2.64} />
    </g>
    <path
      className="se-5"
      d="M424.48,344.96c-.49.33-.99.66-1.5.97-6.91,4.31-14.89,7.07-23.45,7.79-1.49.13-3,.2-4.53.2-.74,0-1.49-.02-2.23-.05-9.85-.4-19-3.5-26.74-8.57-.61-3.9-.58-8.02.23-12.26.62-3.21,1.34-6.37,2.17-9.42.41-1.53.85-3.03,1.33-4.5.02-.06.04-.12.06-.18,2.39-7.43,5.51-13.98,9.49-18.77.03-.03.05-.06.08-.1,4.26-5.08,9.5-8.16,15.88-8.19h.08c6.28,0,11.55,2.84,15.85,7.66.17.19.34.38.5.57,3.93,4.62,7.03,10.93,9.33,18.21.59,1.86,1.13,3.79,1.61,5.77.71,2.88,1.31,5.88,1.8,8.95.66,4.13.63,8.14.04,11.93Z"
    />
    <text className="se-4" transform="translate(177.14 374.49)">
      <tspan x={0} y={0}>
        {"500"}
      </tspan>
    </text>
    <path d="M434.13,325.03c.3-.96-3.45-5.64-6.04-8.82-2.6-3.16-5.38-6.64-8.19-9.36-1.15-1.12-2.83-2.64-4.39-4.04-.34-.32-.68-.62-1.01-.91-1.09-.96-2.03-1.8-2.62-2.31-.39-.35-.62-.55-.62-.55,0,0-.71,6.3-.36,9.1.01.09.02.16.04.25.39,2.78,1.5,6.49,3.6,9.02.37.44.73.83,1.12,1.21.23.22.47.44.72.65.23.2.49.4.77.61.36.28.72.55,1.09.82.06.03.11.08.17.12.15.1.28.21.43.31.81.57,1.64,1.16,2.48,1.83.12.09.24.19.36.28.14.12.27.23.4.34,2.69,2.33,6.48,6,7.46,5.66.99-.35,4.3-3.25,4.6-4.21Z" />
    <path d="M356.42,325.03c-.3-.96,3.45-5.64,6.04-8.82,2.6-3.16,5.38-6.64,8.19-9.36,1.15-1.12,2.83-2.64,4.39-4.04.34-.32.68-.62,1.01-.91,1.09-.96,2.03-1.8,2.62-2.31.39-.35.62-.55.62-.55,0,0,.71,6.3.36,9.1-.01.09-.02.16-.04.25-.39,2.78-1.5,6.49-3.6,9.02-.37.44-.73.83-1.12,1.21-.23.22-.47.44-.72.65-.23.2-.49.4-.77.61-.36.28-.72.55-1.09.82-.06.03-.11.08-.17.12-.15.1-.28.21-.43.31-.81.57-1.64,1.16-2.48,1.83-.12.09-.24.19-.36.28-.14.12-.27.23-.4.34-2.69,2.33-6.48,6-7.46,5.66-.99-.35-4.3-3.25-4.6-4.21Z" />
    <path
      className="se-2"
      d="M420.88,318.32c-4.56,9.33-14.39,15.79-25.76,15.79s-20.77-6.18-25.45-15.17c4.96-15.42,13.07-27.06,25.54-27.06s20.82,11.05,25.68,26.44Z"
    />
    <path
      className="se-1"
      d="M413.37,295.9s.04,0,.04,0c-2.46,7.74-7.73,12.78-9.4,18.33-2.23,7.39-2.9,14.99-3.53,15.68-1.27,1.36-8.85,1.36-10.53,0-.84-.69-.59-7.89-3.11-14.46-2.86-7.44-3.27-8.55-6.95-14.25,0-.01.01-.04.04-.05-2.23-3.39-5.35-9.69-5.35-15.42,0-12.82,9.15-23.21,20.43-23.21s20.43,10.39,20.43,23.21c0,3.66-.74,7.11-2.08,10.19Z"
    />
    <g>
      <path
        className="se-7"
        d="M379.54,293.21c.66-.27,1.1-.54,1.37-1.2.27-.66.14-1.16-.15-1.81-.29-.65-.99-1.25-1.59-1.51-.6-.26-1.02-.35-1.67-.23-.65.12-1.66.76-1.9,1.42-.24.66-.14,1.16.15,1.81.28.65.8,1.19,1.59,1.51.8.32,1.54.28,2.2.01Z"
      />
      <path
        className="se-7"
        d="M410.33,293.18c-.66-.26-1.11-.52-1.39-1.17-.28-.65-.16-1.15.11-1.81.27-.66.96-1.27,1.56-1.54.6-.27,1.02-.37,1.67-.27.65.1,1.67.72,1.93,1.38.26.66.16,1.15-.11,1.81-.27.66-.77,1.21-1.56,1.54-.79.34-1.54.31-2.2.05Z"
      />
    </g>
    <path
      className="se-6"
      d="M383.49,267.04c-2.05,1.68-3.97,3.75-5.35,6.16-1.79-.86-3.64-2.04-3.9-3.29-.49-2.3.51-4.7,1.96-5.68,1.45-.98,2.75-1.02,4.45-.59.83.21,1.93,1.81,2.83,3.39Z"
    />
    <path
      className="se-6"
      d="M415.94,269.92c-.26,1.25-2.37,2.43-4.16,3.29-1.37-2.41-2.96-4.04-5.01-5.73.9-1.57,1.92-3.62,2.75-3.82,1.7-.44,3-.39,4.45.59,1.45.98,2.45,3.38,1.96,5.68Z"
    />
    <path
      className="se-3"
      d="M382.43,282.54c.04-2.74-2.15-5-4.91-5.05-2.75-.04-5.02,2.15-5.07,4.89-.04,2.74,2.15,5,4.91,5.05,2.75.04,5.02-2.15,5.06-4.89Z"
    />
    <path d="M377.92,286.63c2.25.35,4.16-1.55,3.82-3.8-.21-1.4-1.36-2.53-2.75-2.75-2.25-.35-4.16,1.55-3.82,3.8.21,1.4,1.36,2.53,2.75,2.75Z" />
    <path
      className="se-3"
      d="M417.34,282.54c.04-2.74-2.15-5-4.91-5.05-2.75-.04-5.02,2.15-5.06,4.89-.04,2.74,2.15,5,4.91,5.05,2.75.04,5.02-2.15,5.07-4.89Z"
    />
    <path d="M410.81,286.45c2.25.35,4.16-1.56,3.82-3.8-.21-1.4-1.36-2.53-2.75-2.75-2.25-.35-4.16,1.56-3.82,3.8.21,1.4,1.36,2.53,2.75,2.75Z" />
    <g>
      <circle className="se-7" cx={232.8} cy={240.35} r={1.37} />
      <circle className="se-7" cx={230.38} cy={237.69} r={1.37} />
      <circle className="se-7" cx={231.11} cy={234.22} r={1.37} />
      <circle className="se-7" cx={234.56} cy={236.53} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={237.41} cy={263.25} r={1.37} />
      <circle className="se-7" cx={240.9} cy={264.12} r={1.37} />
      <circle className="se-7" cx={242.22} cy={267.41} r={1.37} />
      <circle className="se-7" cx={238.06} cy={267.41} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={285.33} cy={275.62} r={1.37} />
      <circle className="se-7" cx={288.83} cy={276.49} r={1.37} />
      <circle className="se-7" cx={290.14} cy={279.78} r={1.37} />
      <circle className="se-7" cx={285.99} cy={279.78} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={253.53} cy={276.36} r={1.37} />
      <circle className="se-7" cx={252.09} cy={279.65} r={1.37} />
      <circle className="se-7" cx={248.62} cy={280.4} r={1.37} />
      <circle className="se-7" cx={249.32} cy={276.31} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={226.85} cy={285.58} r={1.37} />
      <circle className="se-7" cx={224.43} cy={282.92} r={1.37} />
      <circle className="se-7" cx={225.16} cy={279.45} r={1.37} />
      <circle className="se-7" cx={228.61} cy={281.75} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={238.22} cy={280.77} r={1.37} />
      <circle className="se-7" cx={241.71} cy={281.64} r={1.37} />
      <circle className="se-7" cx={243.03} cy={284.94} r={1.37} />
      <circle className="se-7" cx={238.87} cy={284.94} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={302.64} cy={290.42} r={1.37} />
      <circle className="se-7" cx={301.2} cy={293.72} r={1.37} />
      <circle className="se-7" cx={297.73} cy={294.46} r={1.37} />
      <circle className="se-7" cx={298.42} cy={290.37} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={299.15} cy={328.14} r={1.37} />
      <circle className="se-7" cx={302.65} cy={328.97} r={1.37} />
      <circle className="se-7" cx={304.01} cy={332.25} r={1.37} />
      <circle className="se-7" cx={299.86} cy={332.3} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={297.9} cy={312.36} r={1.37} />
      <circle className="se-7" cx={298.6} cy={308.83} r={1.37} />
      <circle className="se-7" cx={301.82} cy={307.35} r={1.37} />
      <circle className="se-7" cx={302.03} cy={311.49} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={271.38} cy={293.29} r={1.37} />
      <circle className="se-7" cx={268.95} cy={290.62} r={1.37} />
      <circle className="se-7" cx={269.69} cy={287.15} r={1.37} />
      <circle className="se-7" cx={273.14} cy={289.46} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={277.75} cy={300.43} r={1.37} />
      <circle className="se-7" cx={281.24} cy={301.3} r={1.37} />
      <circle className="se-7" cx={282.56} cy={304.59} r={1.37} />
      <circle className="se-7" cx={278.41} cy={304.59} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={339.65} cy={246.45} r={1.37} />
      <circle className="se-7" cx={343.15} cy={247.27} r={1.37} />
      <circle className="se-7" cx={344.51} cy={250.55} r={1.37} />
      <circle className="se-7" cx={340.36} cy={250.6} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={292.87} cy={238.44} r={1.37} />
      <circle className="se-7" cx={290.45} cy={235.78} r={1.37} />
      <circle className="se-7" cx={291.18} cy={232.31} r={1.37} />
      <circle className="se-7" cx={294.64} cy={234.61} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={359.18} cy={267.34} r={1.37} />
      <circle className="se-7" cx={357.74} cy={270.64} r={1.37} />
      <circle className="se-7" cx={354.27} cy={271.39} r={1.37} />
      <circle className="se-7" cx={354.97} cy={267.3} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={341.65} cy={282.93} r={1.37} />
      <circle className="se-7" cx={342.34} cy={279.4} r={1.37} />
      <circle className="se-7" cx={345.57} cy={277.92} r={1.37} />
      <circle className="se-7" cx={345.78} cy={282.06} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={331.23} cy={270.54} r={1.37} />
      <circle className="se-7" cx={328.81} cy={267.88} r={1.37} />
      <circle className="se-7" cx={329.54} cy={264.41} r={1.37} />
      <circle className="se-7" cx={332.99} cy={266.71} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={329.14} cy={288.99} r={1.37} />
      <circle className="se-7" cx={332.64} cy={289.86} r={1.37} />
      <circle className="se-7" cx={333.95} cy={293.15} r={1.37} />
      <circle className="se-7" cx={329.8} cy={293.15} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={355.21} cy={291.93} r={1.37} />
      <circle className="se-7" cx={353.76} cy={295.23} r={1.37} />
      <circle className="se-7" cx={350.3} cy={295.98} r={1.37} />
      <circle className="se-7" cx={350.99} cy={291.88} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={350.39} cy={321.42} r={1.37} />
      <circle className="se-7" cx={353.89} cy={322.24} r={1.37} />
      <circle className="se-7" cx={355.25} cy={325.52} r={1.37} />
      <circle className="se-7" cx={351.1} cy={325.57} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={289.91} cy={338.77} r={1.37} />
      <circle className="se-7" cx={293.42} cy={339.59} r={1.37} />
      <circle className="se-7" cx={294.78} cy={342.87} r={1.37} />
      <circle className="se-7" cx={290.62} cy={342.92} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={273.03} cy={334.12} r={1.37} />
      <circle className="se-7" cx={273.72} cy={330.59} r={1.37} />
      <circle className="se-7" cx={276.94} cy={329.11} r={1.37} />
      <circle className="se-7" cx={277.15} cy={333.25} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={257.37} cy={346.4} r={1.37} />
      <circle className="se-7" cx={260.86} cy={347.27} r={1.37} />
      <circle className="se-7" cx={262.18} cy={350.56} r={1.37} />
      <circle className="se-7" cx={258.03} cy={350.56} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={218.34} cy={336.1} r={1.37} />
      <circle className="se-7" cx={221.84} cy={336.97} r={1.37} />
      <circle className="se-7" cx={223.15} cy={340.27} r={1.37} />
      <circle className="se-7" cx={219} cy={340.27} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={204.8} cy={271.83} r={1.37} />
      <circle className="se-7" cx={203.36} cy={275.13} r={1.37} />
      <circle className="se-7" cx={199.89} cy={275.88} r={1.37} />
      <circle className="se-7" cx={200.59} cy={271.79} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={202.44} cy={289.8} r={1.37} />
      <circle className="se-7" cx={205.94} cy={290.63} r={1.37} />
      <circle className="se-7" cx={207.3} cy={293.9} r={1.37} />
      <circle className="se-7" cx={203.15} cy={293.95} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={193.52} cy={286.42} r={1.37} />
      <circle className="se-7" cx={194.21} cy={282.88} r={1.37} />
      <circle className="se-7" cx={197.43} cy={281.4} r={1.37} />
      <circle className="se-7" cx={197.64} cy={285.55} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={221.37} cy={233.85} r={1.37} />
      <circle className="se-7" cx={219.92} cy={237.14} r={1.37} />
      <circle className="se-7" cx={216.46} cy={237.89} r={1.37} />
      <circle className="se-7" cx={217.15} cy={233.8} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={218.76} cy={254.05} r={1.37} />
      <circle className="se-7" cx={222.26} cy={254.88} r={1.37} />
      <circle className="se-7" cx={223.62} cy={258.16} r={1.37} />
      <circle className="se-7" cx={219.47} cy={258.21} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={204.12} cy={249.75} r={1.37} />
      <circle className="se-7" cx={204.81} cy={246.22} r={1.37} />
      <circle className="se-7" cx={208.03} cy={244.74} r={1.37} />
      <circle className="se-7" cx={208.24} cy={248.89} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={227.15} cy={218.27} r={1.37} />
      <circle className="se-7" cx={230.65} cy={219.1} r={1.37} />
      <circle className="se-7" cx={232.01} cy={222.38} r={1.37} />
      <circle className="se-7" cx={227.86} cy={222.43} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={212.51} cy={213.98} r={1.37} />
      <circle className="se-7" cx={213.2} cy={210.44} r={1.37} />
      <circle className="se-7" cx={216.42} cy={208.96} r={1.37} />
      <circle className="se-7" cx={216.64} cy={213.11} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={230.2} cy={348.47} r={1.37} />
      <circle className="se-7" cx={228.76} cy={351.77} r={1.37} />
      <circle className="se-7" cx={225.29} cy={352.52} r={1.37} />
      <circle className="se-7" cx={225.98} cy={348.42} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={227.59} cy={368.68} r={1.37} />
      <circle className="se-7" cx={231.1} cy={369.51} r={1.37} />
      <circle className="se-7" cx={232.45} cy={372.78} r={1.37} />
      <circle className="se-7" cx={228.3} cy={372.83} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={216.49} cy={363.94} r={1.37} />
      <circle className="se-7" cx={217.18} cy={360.41} r={1.37} />
      <circle className="se-7" cx={220.4} cy={358.92} r={1.37} />
      <circle className="se-7" cx={220.61} cy={363.07} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={200.56} cy={354.29} r={1.37} />
      <circle className="se-7" cx={198.14} cy={351.62} r={1.37} />
      <circle className="se-7" cx={198.87} cy={348.15} r={1.37} />
      <circle className="se-7" cx={202.32} cy={350.46} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={203.89} cy={332.57} r={1.37} />
      <circle className="se-7" cx={207.4} cy={333.39} r={1.37} />
      <circle className="se-7" cx={208.75} cy={336.67} r={1.37} />
      <circle className="se-7" cx={204.6} cy={336.72} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={191.01} cy={328.16} r={1.37} />
      <circle className="se-7" cx={191.7} cy={324.63} r={1.37} />
      <circle className="se-7" cx={194.93} cy={323.14} r={1.37} />
      <circle className="se-7" cx={195.14} cy={327.29} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={392.54} cy={357.34} r={1.37} />
      <circle className="se-7" cx={391.09} cy={360.64} r={1.37} />
      <circle className="se-7" cx={387.63} cy={361.39} r={1.37} />
      <circle className="se-7" cx={388.32} cy={357.29} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={392.36} cy={368.79} r={1.37} />
      <circle className="se-7" cx={395.86} cy={369.61} r={1.37} />
      <circle className="se-7" cx={397.22} cy={372.89} r={1.37} />
      <circle className="se-7" cx={393.07} cy={372.94} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={363.58} cy={362.5} r={1.37} />
      <circle className="se-7" cx={364.27} cy={358.97} r={1.37} />
      <circle className="se-7" cx={367.49} cy={357.48} r={1.37} />
      <circle className="se-7" cx={367.71} cy={361.63} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={345.83} cy={351.07} r={1.37} />
      <circle className="se-7" cx={343.41} cy={348.4} r={1.37} />
      <circle className="se-7" cx={344.14} cy={344.93} r={1.37} />
      <circle className="se-7" cx={347.6} cy={347.24} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={415.04} cy={371.41} r={1.37} />
      <circle className="se-7" cx={415.73} cy={367.87} r={1.37} />
      <circle className="se-7" cx={418.95} cy={366.39} r={1.37} />
      <circle className="se-7" cx={419.17} cy={370.54} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={440.26} cy={330.33} r={1.37} />
      <circle className="se-7" cx={438.82} cy={333.63} r={1.37} />
      <circle className="se-7" cx={435.35} cy={334.38} r={1.37} />
      <circle className="se-7" cx={436.04} cy={330.28} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={437.65} cy={350.54} r={1.37} />
      <circle className="se-7" cx={441.16} cy={351.36} r={1.37} />
      <circle className="se-7" cx={442.52} cy={354.64} r={1.37} />
      <circle className="se-7" cx={438.36} cy={354.69} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={423.01} cy={346.24} r={1.37} />
      <circle className="se-7" cx={423.7} cy={342.7} r={1.37} />
      <circle className="se-7" cx={426.92} cy={341.22} r={1.37} />
      <circle className="se-7" cx={427.14} cy={345.37} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={405.8} cy={350.35} r={1.37} />
      <circle className="se-7" cx={409.3} cy={351.22} r={1.37} />
      <circle className="se-7" cx={410.61} cy={354.52} r={1.37} />
      <circle className="se-7" cx={406.46} cy={354.52} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={454.84} cy={297.2} r={1.37} />
      <circle className="se-7" cx={453.4} cy={300.5} r={1.37} />
      <circle className="se-7" cx={449.93} cy={301.25} r={1.37} />
      <circle className="se-7" cx={450.62} cy={297.15} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={437.59} cy={313.11} r={1.37} />
      <circle className="se-7" cx={438.28} cy={309.57} r={1.37} />
      <circle className="se-7" cx={441.5} cy={308.09} r={1.37} />
      <circle className="se-7" cx={441.71} cy={312.24} r={2.64} />
    </g>
    <g>
      <ellipse
        className="se-7"
        cx={459.71}
        cy={262.33}
        rx={1.49}
        ry={1.37}
        transform="translate(-49.2 407.79) rotate(-45.66)"
      />
      <ellipse
        className="se-7"
        cx={458.05}
        cy={265.85}
        rx={1.49}
        ry={1.37}
        transform="translate(-52.22 407.66) rotate(-45.66)"
      />
      <ellipse
        className="se-7"
        cx={454.39}
        cy={266.79}
        rx={1.49}
        ry={1.37}
        transform="translate(-53.99 405.33) rotate(-45.66)"
      />
      <ellipse
        className="se-7"
        cx={455.3}
        cy={262.47}
        rx={2.88}
        ry={2.64}
        transform="translate(-50.63 404.68) rotate(-45.66)"
      />
    </g>
    <g>
      <circle className="se-7" cx={460.62} cy={282.29} r={1.37} />
      <circle className="se-7" cx={464.13} cy={283.12} r={1.37} />
      <circle className="se-7" cx={465.48} cy={286.39} r={1.37} />
      <circle className="se-7" cx={461.33} cy={286.45} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={445.98} cy={277.99} r={1.37} />
      <circle className="se-7" cx={446.67} cy={274.46} r={1.37} />
      <circle className="se-7" cx={449.89} cy={272.97} r={1.37} />
      <circle className="se-7" cx={450.11} cy={277.12} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={445.12} cy={232.05} r={1.37} />
      <circle className="se-7" cx={443.68} cy={235.34} r={1.37} />
      <circle className="se-7" cx={440.21} cy={236.09} r={1.37} />
      <circle className="se-7" cx={440.9} cy={232} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={442.51} cy={252.25} r={1.37} />
      <circle className="se-7" cx={446.02} cy={253.08} r={1.37} />
      <circle className="se-7" cx={447.37} cy={256.36} r={1.37} />
      <circle className="se-7" cx={443.22} cy={256.41} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={431.57} cy={252.18} r={1.37} />
      <circle className="se-7" cx={432.26} cy={248.65} r={1.37} />
      <circle className="se-7" cx={435.48} cy={247.16} r={1.37} />
      <circle className="se-7" cx={435.7} cy={251.31} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={418.42} cy={235.65} r={1.37} />
      <circle className="se-7" cx={416} cy={232.99} r={1.37} />
      <circle className="se-7" cx={416.73} cy={229.52} r={1.37} />
      <circle className="se-7" cx={420.19} cy={231.82} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={394.98} cy={212.39} r={1.37} />
      <circle className="se-7" cx={393.54} cy={215.69} r={1.37} />
      <circle className="se-7" cx={390.08} cy={216.44} r={1.37} />
      <circle className="se-7" cx={390.77} cy={212.34} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={406.73} cy={227.74} r={1.37} />
      <circle className="se-7" cx={410.24} cy={228.56} r={1.37} />
      <circle className="se-7" cx={411.6} cy={231.84} r={1.37} />
      <circle className="se-7" cx={407.44} cy={231.89} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={382.25} cy={226.09} r={1.37} />
      <circle className="se-7" cx={382.94} cy={222.56} r={1.37} />
      <circle className="se-7" cx={386.16} cy={221.08} r={1.37} />
      <circle className="se-7" cx={386.38} cy={225.22} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={363.4} cy={221.37} r={1.37} />
      <circle className="se-7" cx={366.89} cy={222.24} r={1.37} />
      <circle className="se-7" cx={368.21} cy={225.53} r={1.37} />
      <circle className="se-7" cx={364.06} cy={225.53} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={410.88} cy={213.42} r={1.37} />
      <circle className="se-7" cx={414.38} cy={214.29} r={1.37} />
      <circle className="se-7" cx={415.69} cy={217.58} r={1.37} />
      <circle className="se-7" cx={411.54} cy={217.58} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={356.63} cy={344.48} r={1.37} />
      <circle className="se-7" cx={360.13} cy={345.36} r={1.37} />
      <circle className="se-7" cx={361.44} cy={348.65} r={1.37} />
      <circle className="se-7" cx={357.29} cy={348.65} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={288.29} cy={212.94} r={1.37} />
      <circle className="se-7" cx={286.84} cy={216.24} r={1.37} />
      <circle className="se-7" cx={283.38} cy={216.98} r={1.37} />
      <circle className="se-7" cx={284.07} cy={212.89} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={272.72} cy={232.11} r={1.37} />
      <circle className="se-7" cx={276.23} cy={232.94} r={1.37} />
      <circle className="se-7" cx={277.58} cy={236.22} r={1.37} />
      <circle className="se-7" cx={273.43} cy={236.27} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={261.1} cy={224.58} r={1.37} />
      <circle className="se-7" cx={261.79} cy={221.04} r={1.37} />
      <circle className="se-7" cx={265.01} cy={219.56} r={1.37} />
      <circle className="se-7" cx={265.22} cy={223.71} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={246.86} cy={217.87} r={1.37} />
      <circle className="se-7" cx={244.44} cy={215.21} r={1.37} />
      <circle className="se-7" cx={245.17} cy={211.74} r={1.37} />
      <circle className="se-7" cx={248.63} cy={214.04} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={246.76} cy={226.48} r={1.37} />
      <circle className="se-7" cx={250.25} cy={227.35} r={1.37} />
      <circle className="se-7" cx={251.57} cy={230.65} r={1.37} />
      <circle className="se-7" cx={247.42} cy={230.65} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={348.53} cy={242.16} r={1.37} />
      <circle className="se-7" cx={346.11} cy={239.5} r={1.37} />
      <circle className="se-7" cx={346.84} cy={236.03} r={1.37} />
      <circle className="se-7" cx={350.3} cy={238.34} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={350.64} cy={251.22} r={1.37} />
      <circle className="se-7" cx={354.13} cy={252.09} r={1.37} />
      <circle className="se-7" cx={355.45} cy={255.38} r={1.37} />
      <circle className="se-7" cx={351.29} cy={255.38} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={345.05} cy={332.35} r={1.37} />
      <circle className="se-7" cx={343.6} cy={335.65} r={1.37} />
      <circle className="se-7" cx={340.14} cy={336.4} r={1.37} />
      <circle className="se-7" cx={340.83} cy={332.3} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={514.28} cy={266.85} r={1.37} />
      <circle className="se-7" cx={512.84} cy={270.15} r={1.37} />
      <circle className="se-7" cx={509.37} cy={270.9} r={1.37} />
      <circle className="se-7" cx={510.06} cy={266.8} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={502.6} cy={283.66} r={1.37} />
      <circle className="se-7" cx={503.29} cy={280.12} r={1.37} />
      <circle className="se-7" cx={506.51} cy={278.64} r={1.37} />
      <circle className="se-7" cx={506.73} cy={282.79} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={497.96} cy={266.16} r={1.37} />
      <circle className="se-7" cx={495.54} cy={263.5} r={1.37} />
      <circle className="se-7" cx={496.27} cy={260.03} r={1.37} />
      <circle className="se-7" cx={499.72} cy={262.33} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={490.09} cy={289.71} r={1.37} />
      <circle className="se-7" cx={493.58} cy={290.58} r={1.37} />
      <circle className="se-7" cx={494.9} cy={293.87} r={1.37} />
      <circle className="se-7" cx={490.75} cy={293.87} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={514.41} cy={291.41} r={1.37} />
      <circle className="se-7" cx={512.97} cy={294.7} r={1.37} />
      <circle className="se-7" cx={509.5} cy={295.45} r={1.37} />
      <circle className="se-7" cx={510.2} cy={291.36} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={511.34} cy={322.14} r={1.37} />
      <circle className="se-7" cx={514.84} cy={322.96} r={1.37} />
      <circle className="se-7" cx={516.2} cy={326.24} r={1.37} />
      <circle className="se-7" cx={512.05} cy={326.29} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={510.39} cy={311.88} r={1.37} />
      <circle className="se-7" cx={511.08} cy={308.34} r={1.37} />
      <circle className="se-7" cx={514.3} cy={306.86} r={1.37} />
      <circle className="se-7" cx={514.52} cy={311.01} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={541.78} cy={347.02} r={1.37} />
      <circle className="se-7" cx={540.34} cy={350.32} r={1.37} />
      <circle className="se-7" cx={536.87} cy={351.07} r={1.37} />
      <circle className="se-7" cx={537.56} cy={346.97} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={546.02} cy={366.42} r={1.37} />
      <circle className="se-7" cx={549.52} cy={367.24} r={1.37} />
      <circle className="se-7" cx={550.88} cy={370.52} r={1.37} />
      <circle className="se-7" cx={546.73} cy={370.57} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={522.17} cy={360.29} r={1.37} />
      <circle className="se-7" cx={522.86} cy={356.75} r={1.37} />
      <circle className="se-7" cx={526.09} cy={355.27} r={1.37} />
      <circle className="se-7" cx={526.3} cy={359.42} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={575.4} cy={370.17} r={1.37} />
      <circle className="se-7" cx={576.09} cy={366.64} r={1.37} />
      <circle className="se-7" cx={579.31} cy={365.16} r={1.37} />
      <circle className="se-7" cx={579.52} cy={369.3} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={551.61} cy={362.95} r={1.37} />
      <circle className="se-7" cx={549.19} cy={360.29} r={1.37} />
      <circle className="se-7" cx={549.92} cy={356.82} r={1.37} />
      <circle className="se-7" cx={553.37} cy={359.12} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={601.21} cy={331.05} r={1.37} />
      <circle className="se-7" cx={599.77} cy={334.35} r={1.37} />
      <circle className="se-7" cx={596.3} cy={335.1} r={1.37} />
      <circle className="se-7" cx={596.99} cy={331} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={598.6} cy={351.26} r={1.37} />
      <circle className="se-7" cx={602.11} cy={352.08} r={1.37} />
      <circle className="se-7" cx={603.46} cy={355.36} r={1.37} />
      <circle className="se-7" cx={599.31} cy={355.41} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={612.04} cy={330.51} r={1.37} />
      <circle className="se-7" cx={615.54} cy={331.34} r={1.37} />
      <circle className="se-7" cx={616.9} cy={334.61} r={1.37} />
      <circle className="se-7" cx={612.75} cy={334.67} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={587.58} cy={350.95} r={1.37} />
      <circle className="se-7" cx={588.27} cy={347.42} r={1.37} />
      <circle className="se-7" cx={591.49} cy={345.93} r={1.37} />
      <circle className="se-7" cx={591.7} cy={350.08} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={565.11} cy={354.31} r={1.37} />
      <circle className="se-7" cx={568.6} cy={355.18} r={1.37} />
      <circle className="se-7" cx={569.92} cy={358.48} r={1.37} />
      <circle className="se-7" cx={565.77} cy={358.48} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={615.79} cy={297.92} r={1.37} />
      <circle className="se-7" cx={614.34} cy={301.22} r={1.37} />
      <circle className="se-7" cx={610.88} cy={301.97} r={1.37} />
      <circle className="se-7" cx={611.57} cy={297.87} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={613.18} cy={318.13} r={1.37} />
      <circle className="se-7" cx={616.68} cy={318.95} r={1.37} />
      <circle className="se-7" cx={618.04} cy={322.23} r={1.37} />
      <circle className="se-7" cx={613.89} cy={322.28} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={608.78} cy={312.08} r={1.37} />
      <circle className="se-7" cx={609.47} cy={308.55} r={1.37} />
      <circle className="se-7" cx={612.69} cy={307.06} r={1.37} />
      <circle className="se-7" cx={612.9} cy={311.21} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={624.18} cy={262.8} r={1.37} />
      <circle className="se-7" cx={622.74} cy={266.1} r={1.37} />
      <circle className="se-7" cx={619.27} cy={266.85} r={1.37} />
      <circle className="se-7" cx={619.96} cy={262.76} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={621.57} cy={283.01} r={1.37} />
      <circle className="se-7" cx={625.08} cy={283.84} r={1.37} />
      <circle className="se-7" cx={626.43} cy={287.11} r={1.37} />
      <circle className="se-7" cx={622.28} cy={287.17} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={606.93} cy={278.71} r={1.37} />
      <circle className="se-7" cx={607.62} cy={275.18} r={1.37} />
      <circle className="se-7" cx={610.84} cy={273.7} r={1.37} />
      <circle className="se-7" cx={611.06} cy={277.84} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={601.19} cy={272.01} r={1.37} />
      <circle className="se-7" cx={598.77} cy={269.35} r={1.37} />
      <circle className="se-7" cx={599.5} cy={265.88} r={1.37} />
      <circle className="se-7" cx={602.96} cy={268.18} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={606.07} cy={232.77} r={1.37} />
      <circle className="se-7" cx={604.63} cy={236.07} r={1.37} />
      <circle className="se-7" cx={601.16} cy={236.81} r={1.37} />
      <circle className="se-7" cx={601.85} cy={232.72} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={595} cy={248.38} r={1.37} />
      <circle className="se-7" cx={595.7} cy={244.85} r={1.37} />
      <circle className="se-7" cx={598.92} cy={243.37} r={1.37} />
      <circle className="se-7" cx={599.13} cy={247.51} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={589.97} cy={233.72} r={1.37} />
      <circle className="se-7" cx={587.55} cy={231.06} r={1.37} />
      <circle className="se-7" cx={588.28} cy={227.59} r={1.37} />
      <circle className="se-7" cx={591.74} cy={229.9} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={558.36} cy={208.03} r={1.37} />
      <circle className="se-7" cx={556.92} cy={211.33} r={1.37} />
      <circle className="se-7" cx={553.45} cy={212.08} r={1.37} />
      <circle className="se-7" cx={554.15} cy={207.98} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={555.76} cy={228.24} r={1.37} />
      <circle className="se-7" cx={559.26} cy={229.07} r={1.37} />
      <circle className="se-7" cx={560.62} cy={232.34} r={1.37} />
      <circle className="se-7" cx={556.46} cy={232.39} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={566.31} cy={214.36} r={1.37} />
      <circle className="se-7" cx={569.8} cy={215.23} r={1.37} />
      <circle className="se-7" cx={571.12} cy={218.53} r={1.37} />
      <circle className="se-7" cx={566.97} cy={218.53} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={524.87} cy={336} r={1.37} />
      <circle className="se-7" cx={528.36} cy={336.87} r={1.37} />
      <circle className="se-7" cx={529.68} cy={340.17} r={1.37} />
      <circle className="se-7" cx={525.52} cy={340.17} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={532.23} cy={243.57} r={1.37} />
      <circle className="se-7" cx={530.79} cy={246.87} r={1.37} />
      <circle className="se-7" cx={527.32} cy={247.61} r={1.37} />
      <circle className="se-7" cx={528.01} cy={243.52} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={509.48} cy={242.89} r={1.37} />
      <circle className="se-7" cx={507.06} cy={240.22} r={1.37} />
      <circle className="se-7" cx={507.79} cy={236.75} r={1.37} />
      <circle className="se-7" cx={511.25} cy={239.06} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={511.59} cy={251.94} r={1.37} />
      <circle className="se-7" cx={515.08} cy={252.81} r={1.37} />
      <circle className="se-7" cx={516.4} cy={256.11} r={1.37} />
      <circle className="se-7" cx={512.24} cy={256.11} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={505.99} cy={333.07} r={1.37} />
      <circle className="se-7" cx={504.55} cy={336.37} r={1.37} />
      <circle className="se-7" cx={501.09} cy={337.12} r={1.37} />
      <circle className="se-7" cx={501.78} cy={333.02} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={624.45} cy={311.94} r={1.37} />
      <circle className="se-7" cx={620.94} cy={311.11} r={1.37} />
      <circle className="se-7" cx={619.58} cy={307.83} r={1.37} />
      <circle className="se-7" cx={623.74} cy={307.78} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={594.59} cy={313.77} r={1.37} />
      <circle className="se-7" cx={596.04} cy={310.47} r={1.37} />
      <circle className="se-7" cx={599.5} cy={309.72} r={1.37} />
      <circle className="se-7" cx={598.81} cy={313.82} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={601.43} cy={290.04} r={1.37} />
      <circle className="se-7" cx={602.87} cy={286.74} r={1.37} />
      <circle className="se-7" cx={606.33} cy={286} r={1.37} />
      <circle className="se-7" cx={605.64} cy={290.09} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={603.39} cy={259.7} r={1.37} />
      <circle className="se-7" cx={599.88} cy={258.87} r={1.37} />
      <circle className="se-7" cx={598.52} cy={255.59} r={1.37} />
      <circle className="se-7" cx={602.68} cy={255.54} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={613.6} cy={264.01} r={1.37} />
      <circle className="se-7" cx={612.91} cy={267.54} r={1.37} />
      <circle className="se-7" cx={609.69} cy={269.02} r={1.37} />
      <circle className="se-7" cx={609.47} cy={264.88} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={569.95} cy={234.96} r={1.37} />
      <circle className="se-7" cx={571.39} cy={231.66} r={1.37} />
      <circle className="se-7" cx={574.86} cy={230.92} r={1.37} />
      <circle className="se-7" cx={574.17} cy={235.01} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={587.99} cy={214.42} r={1.37} />
      <circle className="se-7" cx={587.29} cy={217.95} r={1.37} />
      <circle className="se-7" cx={584.07} cy={219.43} r={1.37} />
      <circle className="se-7" cx={583.86} cy={215.28} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={522.15} cy={229.66} r={1.37} />
      <circle className="se-7" cx={523.59} cy={226.36} r={1.37} />
      <circle className="se-7" cx={527.06} cy={225.61} r={1.37} />
      <circle className="se-7" cx={526.36} cy={229.71} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={537.41} cy={214.19} r={1.37} />
      <circle className="se-7" cx={536.72} cy={217.73} r={1.37} />
      <circle className="se-7" cx={533.5} cy={219.21} r={1.37} />
      <circle className="se-7" cx={533.28} cy={215.06} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={549.74} cy={218.51} r={1.37} />
      <circle className="se-7" cx={552.16} cy={221.18} r={1.37} />
      <circle className="se-7" cx={551.43} cy={224.65} r={1.37} />
      <circle className="se-7" cx={547.98} cy={222.34} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={514.07} cy={246.37} r={1.37} />
      <circle className="se-7" cx={515.51} cy={243.07} r={1.37} />
      <circle className="se-7" cx={518.98} cy={242.32} r={1.37} />
      <circle className="se-7" cx={518.28} cy={246.41} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={515.91} cy={227.8} r={1.37} />
      <circle className="se-7" cx={512.41} cy={226.97} r={1.37} />
      <circle className="se-7" cx={511.05} cy={223.7} r={1.37} />
      <circle className="se-7" cx={515.2} cy={223.64} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={542.96} cy={230.93} r={1.37} />
      <circle className="se-7" cx={542.26} cy={234.46} r={1.37} />
      <circle className="se-7" cx={539.04} cy={235.94} r={1.37} />
      <circle className="se-7" cx={538.83} cy={231.8} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={501.1} cy={251.12} r={1.37} />
      <circle className="se-7" cx={497.6} cy={250.29} r={1.37} />
      <circle className="se-7" cx={496.24} cy={247.01} r={1.37} />
      <circle className="se-7" cx={500.39} cy={246.96} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={490.55} cy={319.03} r={1.37} />
      <circle className="se-7" cx={491.99} cy={315.73} r={1.37} />
      <circle className="se-7" cx={495.45} cy={314.98} r={1.37} />
      <circle className="se-7" cx={494.76} cy={319.08} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={494.48} cy={278.61} r={1.37} />
      <circle className="se-7" cx={490.97} cy={277.79} r={1.37} />
      <circle className="se-7" cx={489.62} cy={274.51} r={1.37} />
      <circle className="se-7" cx={493.77} cy={274.46} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={504.37} cy={303.23} r={1.37} />
      <circle className="se-7" cx={503.68} cy={306.76} r={1.37} />
      <circle className="se-7" cx={500.46} cy={308.25} r={1.37} />
      <circle className="se-7" cx={500.25} cy={304.1} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={510.87} cy={349.73} r={1.37} />
      <circle className="se-7" cx={512.31} cy={346.43} r={1.37} />
      <circle className="se-7" cx={515.77} cy={345.68} r={1.37} />
      <circle className="se-7" cx={515.08} cy={349.78} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={518.62} cy={336.03} r={1.37} />
      <circle className="se-7" cx={517.93} cy={339.56} r={1.37} />
      <circle className="se-7" cx={514.7} cy={341.05} r={1.37} />
      <circle className="se-7" cx={514.49} cy={336.9} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={559.62} cy={373.14} r={1.37} />
      <circle className="se-7" cx={561.06} cy={369.84} r={1.37} />
      <circle className="se-7" cx={564.52} cy={369.1} r={1.37} />
      <circle className="se-7" cx={563.83} cy={373.19} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={558.97} cy={353.6} r={1.37} />
      <circle className="se-7" cx={555.47} cy={352.77} r={1.37} />
      <circle className="se-7" cx={554.11} cy={349.49} r={1.37} />
      <circle className="se-7" cx={558.26} cy={349.44} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={581.61} cy={350.43} r={1.37} />
      <circle className="se-7" cx={580.92} cy={353.96} r={1.37} />
      <circle className="se-7" cx={577.7} cy={355.45} r={1.37} />
      <circle className="se-7" cx={577.48} cy={351.3} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={588.9} cy={364.1} r={1.37} />
      <circle className="se-7" cx={585.4} cy={363.22} r={1.37} />
      <circle className="se-7" cx={584.09} cy={359.93} r={1.37} />
      <circle className="se-7" cx={588.24} cy={359.93} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={537.93} cy={367.08} r={1.37} />
      <circle className="se-7" cx={534.43} cy={366.21} r={1.37} />
      <circle className="se-7" cx={533.12} cy={362.92} r={1.37} />
      <circle className="se-7" cx={537.27} cy={362.92} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={589.86} cy={245.83} r={1.37} />
      <circle className="se-7" cx={586.36} cy={244.96} r={1.37} />
      <circle className="se-7" cx={585.05} cy={241.67} r={1.37} />
      <circle className="se-7" cx={589.2} cy={241.67} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={583.11} cy={338.21} r={1.37} />
      <circle className="se-7" cx={584.55} cy={334.91} r={1.37} />
      <circle className="se-7" cx={588.02} cy={334.16} r={1.37} />
      <circle className="se-7" cx={587.33} cy={338.26} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={605.24} cy={338.95} r={1.37} />
      <circle className="se-7" cx={607.67} cy={341.61} r={1.37} />
      <circle className="se-7" cx={606.93} cy={345.08} r={1.37} />
      <circle className="se-7" cx={603.48} cy={342.78} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={606.38} cy={326.51} r={1.37} />
      <circle className="se-7" cx={602.88} cy={325.64} r={1.37} />
      <circle className="se-7" cx={601.57} cy={322.34} r={1.37} />
      <circle className="se-7" cx={605.72} cy={322.34} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={608.73} cy={248.76} r={1.37} />
      <circle className="se-7" cx={610.17} cy={245.46} r={1.37} />
      <circle className="se-7" cx={613.64} cy={244.72} r={1.37} />
      <circle className="se-7" cx={612.95} cy={248.81} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={455.36} cy={323.82} r={1.37} />
      <circle className="se-7" cx={451.85} cy={322.99} r={1.37} />
      <circle className="se-7" cx={450.49} cy={319.72} r={1.37} />
      <circle className="se-7" cx={454.65} cy={319.66} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={444.87} cy={294.01} r={1.37} />
      <circle className="se-7" cx={444.18} cy={297.55} r={1.37} />
      <circle className="se-7" cx={440.96} cy={299.03} r={1.37} />
      <circle className="se-7" cx={440.75} cy={294.88} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={463.32} cy={308.21} r={1.37} />
      <circle className="se-7" cx={465.74} cy={310.87} r={1.37} />
      <circle className="se-7" cx={465.01} cy={314.34} r={1.37} />
      <circle className="se-7" cx={461.56} cy={312.03} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={212.88} cy={283.2} r={1.37} />
      <circle className="se-7" cx={209.39} cy={282.33} r={1.37} />
      <circle className="se-7" cx={208.07} cy={279.04} r={1.37} />
      <circle className="se-7" cx={212.23} cy={279.04} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={438.1} cy={279.86} r={1.37} />
      <circle className="se-7" cx={439.54} cy={276.56} r={1.37} />
      <circle className="se-7" cx={443} cy={275.81} r={1.37} />
      <circle className="se-7" cx={442.31} cy={279.91} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={222.54} cy={248.33} r={1.37} />
      <circle className="se-7" cx={223.99} cy={245.03} r={1.37} />
      <circle className="se-7" cx={227.45} cy={244.28} r={1.37} />
      <circle className="se-7" cx={226.76} cy={248.38} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={437.17} cy={266.72} r={1.37} />
      <circle className="se-7" cx={433.66} cy={265.9} r={1.37} />
      <circle className="se-7" cx={432.31} cy={262.62} r={1.37} />
      <circle className="se-7" cx={436.46} cy={262.57} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={406.02} cy={215.37} r={1.37} />
      <circle className="se-7" cx={402.52} cy={214.55} r={1.37} />
      <circle className="se-7" cx={401.16} cy={211.27} r={1.37} />
      <circle className="se-7" cx={405.31} cy={211.22} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={260.77} cy={215.96} r={1.37} />
      <circle className="se-7" cx={257.27} cy={215.13} r={1.37} />
      <circle className="se-7" cx={255.91} cy={211.85} r={1.37} />
      <circle className="se-7" cx={260.06} cy={211.8} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={427.51} cy={218.57} r={1.37} />
      <circle className="se-7" cx={426.82} cy={222.1} r={1.37} />
      <circle className="se-7" cx={423.6} cy={223.59} r={1.37} />
      <circle className="se-7" cx={423.39} cy={219.44} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={430.41} cy={228.15} r={1.37} />
      <circle className="se-7" cx={432.83} cy={230.81} r={1.37} />
      <circle className="se-7" cx={432.1} cy={234.28} r={1.37} />
      <circle className="se-7" cx={428.64} cy={231.98} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={380.03} cy={213.49} r={1.37} />
      <circle className="se-7" cx={379.33} cy={217.02} r={1.37} />
      <circle className="se-7" cx={376.11} cy={218.51} r={1.37} />
      <circle className="se-7" cx={375.9} cy={214.36} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={294.94} cy={221.23} r={1.37} />
      <circle className="se-7" cx={294.24} cy={224.76} r={1.37} />
      <circle className="se-7" cx={291.02} cy={226.24} r={1.37} />
      <circle className="se-7" cx={290.81} cy={222.1} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={221.67} cy={289.69} r={1.37} />
      <circle className="se-7" cx={220.98} cy={293.22} r={1.37} />
      <circle className="se-7" cx={217.76} cy={294.7} r={1.37} />
      <circle className="se-7" cx={217.54} cy={290.55} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={290.14} cy={290.79} r={1.37} />
      <circle className="se-7" cx={289.45} cy={294.32} r={1.37} />
      <circle className="se-7" cx={286.22} cy={295.81} r={1.37} />
      <circle className="se-7" cx={286.01} cy={291.66} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={396.54} cy={224.98} r={1.37} />
      <circle className="se-7" cx={398.97} cy={227.64} r={1.37} />
      <circle className="se-7" cx={398.23} cy={231.11} r={1.37} />
      <circle className="se-7" cx={394.78} cy={228.81} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={353.44} cy={230.53} r={1.37} />
      <circle className="se-7" cx={349.94} cy={229.71} r={1.37} />
      <circle className="se-7" cx={348.58} cy={226.43} r={1.37} />
      <circle className="se-7" cx={352.73} cy={226.38} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={214.52} cy={225.78} r={1.37} />
      <circle className="se-7" cx={211.01} cy={224.96} r={1.37} />
      <circle className="se-7" cx={209.65} cy={221.68} r={1.37} />
      <circle className="se-7" cx={213.81} cy={221.63} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={264.5} cy={238.25} r={1.37} />
      <circle className="se-7" cx={261} cy={237.42} r={1.37} />
      <circle className="se-7" cx={259.64} cy={234.14} r={1.37} />
      <circle className="se-7" cx={263.79} cy={234.09} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={260.68} cy={269.18} r={1.37} />
      <circle className="se-7" cx={257.17} cy={268.36} r={1.37} />
      <circle className="se-7" cx={255.82} cy={265.08} r={1.37} />
      <circle className="se-7" cx={259.97} cy={265.03} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={368.74} cy={243.45} r={1.37} />
      <circle className="se-7" cx={368.05} cy={246.98} r={1.37} />
      <circle className="se-7" cx={364.83} cy={248.46} r={1.37} />
      <circle className="se-7" cx={364.62} cy={244.32} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={208.58} cy={358.16} r={1.37} />
      <circle className="se-7" cx={207.89} cy={361.69} r={1.37} />
      <circle className="se-7" cx={204.67} cy={363.18} r={1.37} />
      <circle className="se-7" cx={204.45} cy={359.03} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={381.28} cy={236.13} r={1.37} />
      <circle className="se-7" cx={377.79} cy={235.25} r={1.37} />
      <circle className="se-7" cx={376.47} cy={231.96} r={1.37} />
      <circle className="se-7" cx={380.63} cy={231.96} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={331.24} cy={279.95} r={1.37} />
      <circle className="se-7" cx={332.68} cy={276.65} r={1.37} />
      <circle className="se-7" cx={336.15} cy={275.9} r={1.37} />
      <circle className="se-7" cx={335.45} cy={280} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={204.41} cy={261.08} r={1.37} />
      <circle className="se-7" cx={205.85} cy={257.78} r={1.37} />
      <circle className="se-7" cx={209.32} cy={257.03} r={1.37} />
      <circle className="se-7" cx={208.63} cy={261.12} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={219.35} cy={269.61} r={1.37} />
      <circle className="se-7" cx={220.79} cy={266.31} r={1.37} />
      <circle className="se-7" cx={224.26} cy={265.56} r={1.37} />
      <circle className="se-7" cx={223.57} cy={269.66} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={287} cy={306.84} r={1.37} />
      <circle className="se-7" cx={288.45} cy={303.54} r={1.37} />
      <circle className="se-7" cx={291.91} cy={302.79} r={1.37} />
      <circle className="se-7" cx={291.22} cy={306.89} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={212.36} cy={328.99} r={1.37} />
      <circle className="se-7" cx={213.81} cy={325.69} r={1.37} />
      <circle className="se-7" cx={217.27} cy={324.94} r={1.37} />
      <circle className="se-7" cx={216.58} cy={329.04} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={344.31} cy={268.23} r={1.37} />
      <circle className="se-7" cx={340.81} cy={267.4} r={1.37} />
      <circle className="se-7" cx={339.45} cy={264.12} r={1.37} />
      <circle className="se-7" cx={343.6} cy={264.07} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={281.07} cy={227.6} r={1.37} />
      <circle className="se-7" cx={277.56} cy={226.77} r={1.37} />
      <circle className="se-7" cx={276.21} cy={223.5} r={1.37} />
      <circle className="se-7" cx={280.36} cy={223.44} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={264.33} cy={286.7} r={1.37} />
      <circle className="se-7" cx={260.83} cy={285.87} r={1.37} />
      <circle className="se-7" cx={259.47} cy={282.59} r={1.37} />
      <circle className="se-7" cx={263.62} cy={282.54} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={280.36} cy={314.21} r={1.37} />
      <circle className="se-7" cx={279.67} cy={317.74} r={1.37} />
      <circle className="se-7" cx={276.45} cy={319.22} r={1.37} />
      <circle className="se-7" cx={276.23} cy={315.08} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={337.14} cy={319.13} r={1.37} />
      <circle className="se-7" cx={338.58} cy={315.83} r={1.37} />
      <circle className="se-7" cx={342.05} cy={315.09} r={1.37} />
      <circle className="se-7" cx={341.35} cy={319.18} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={268.46} cy={277.2} r={1.37} />
      <circle className="se-7" cx={269.9} cy={273.9} r={1.37} />
      <circle className="se-7" cx={273.37} cy={273.16} r={1.37} />
      <circle className="se-7" cx={272.67} cy={277.25} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={229.59} cy={363.12} r={1.37} />
      <circle className="se-7" cx={231.03} cy={359.82} r={1.37} />
      <circle className="se-7" cx={234.49} cy={359.07} r={1.37} />
      <circle className="se-7" cx={233.8} cy={363.17} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={334.37} cy={316.37} r={1.37} />
      <circle className="se-7" cx={330.87} cy={315.55} r={1.37} />
      <circle className="se-7" cx={329.51} cy={312.27} r={1.37} />
      <circle className="se-7" cx={333.66} cy={312.22} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={195.06} cy={337.93} r={1.37} />
      <circle className="se-7" cx={191.56} cy={337.1} r={1.37} />
      <circle className="se-7" cx={190.2} cy={333.82} r={1.37} />
      <circle className="se-7" cx={194.35} cy={333.77} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={343.52} cy={298.97} r={1.37} />
      <circle className="se-7" cx={342.83} cy={302.5} r={1.37} />
      <circle className="se-7" cx={339.61} cy={303.99} r={1.37} />
      <circle className="se-7" cx={339.4} cy={299.84} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={353.38} cy={309.12} r={1.37} />
      <circle className="se-7" cx={355.8} cy={311.79} r={1.37} />
      <circle className="se-7" cx={355.07} cy={315.26} r={1.37} />
      <circle className="se-7" cx={351.62} cy={312.95} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={213.72} cy={346.53} r={1.37} />
      <circle className="se-7" cx={216.15} cy={349.19} r={1.37} />
      <circle className="se-7" cx={215.41} cy={352.66} r={1.37} />
      <circle className="se-7" cx={211.96} cy={350.36} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={248.99} cy={363.69} r={1.37} />
      <circle className="se-7" cx={250.43} cy={360.39} r={1.37} />
      <circle className="se-7" cx={253.9} cy={359.64} r={1.37} />
      <circle className="se-7" cx={253.21} cy={363.73} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={272.6} cy={355.54} r={1.37} />
      <circle className="se-7" cx={269.1} cy={354.71} r={1.37} />
      <circle className="se-7" cx={267.74} cy={351.44} r={1.37} />
      <circle className="se-7" cx={271.9} cy={351.38} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={363.22} cy={333.11} r={1.37} />
      <circle className="se-7" cx={362.53} cy={336.65} r={1.37} />
      <circle className="se-7" cx={359.31} cy={338.13} r={1.37} />
      <circle className="se-7" cx={359.1} cy={333.98} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={372.67} cy={345.42} r={1.37} />
      <circle className="se-7" cx={375.09} cy={348.08} r={1.37} />
      <circle className="se-7" cx={374.36} cy={351.55} r={1.37} />
      <circle className="se-7" cx={370.91} cy={349.25} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={400.08} cy={366.91} r={1.37} />
      <circle className="se-7" cx={401.53} cy={363.61} r={1.37} />
      <circle className="se-7" cx={404.99} cy={362.87} r={1.37} />
      <circle className="se-7" cx={404.3} cy={366.96} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={302.28} cy={323.72} r={1.37} />
      <circle className="se-7" cx={298.78} cy={322.84} r={1.37} />
      <circle className="se-7" cx={297.47} cy={319.55} r={1.37} />
      <circle className="se-7" cx={301.62} cy={319.55} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={380.21} cy={367.65} r={1.37} />
      <circle className="se-7" cx={376.72} cy={366.78} r={1.37} />
      <circle className="se-7" cx={375.4} cy={363.49} r={1.37} />
      <circle className="se-7" cx={379.55} cy={363.49} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={289.86} cy={326.86} r={1.37} />
      <circle className="se-7" cx={286.37} cy={325.99} r={1.37} />
      <circle className="se-7" cx={285.05} cy={322.69} r={1.37} />
      <circle className="se-7" cx={289.2} cy={322.69} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={277.29} cy={366.77} r={1.37} />
      <circle className="se-7" cx={273.8} cy={365.9} r={1.37} />
      <circle className="se-7" cx={272.48} cy={362.6} r={1.37} />
      <circle className="se-7" cx={276.63} cy={362.6} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={427.17} cy={245.79} r={1.37} />
      <circle className="se-7" cx={423.68} cy={244.92} r={1.37} />
      <circle className="se-7" cx={422.36} cy={241.62} r={1.37} />
      <circle className="se-7" cx={426.52} cy={241.62} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={421.6} cy={359.08} r={1.37} />
      <circle className="se-7" cx={423.05} cy={355.78} r={1.37} />
      <circle className="se-7" cx={426.51} cy={355.03} r={1.37} />
      <circle className="se-7" cx={425.82} cy={359.12} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={283.71} cy={353.85} r={1.37} />
      <circle className="se-7" cx={285.16} cy={350.55} r={1.37} />
      <circle className="se-7" cx={288.62} cy={349.8} r={1.37} />
      <circle className="se-7" cx={287.93} cy={353.9} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={448.6} cy={342.29} r={1.37} />
      <circle className="se-7" cx={451.02} cy={344.95} r={1.37} />
      <circle className="se-7" cx={450.29} cy={348.42} r={1.37} />
      <circle className="se-7" cx={446.83} cy={346.12} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={450.91} cy={333.68} r={1.37} />
      <circle className="se-7" cx={447.41} cy={332.81} r={1.37} />
      <circle className="se-7" cx={446.1} cy={329.51} r={1.37} />
      <circle className="se-7" cx={450.25} cy={329.51} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={446.05} cy={248.72} r={1.37} />
      <circle className="se-7" cx={447.49} cy={245.42} r={1.37} />
      <circle className="se-7" cx={450.95} cy={244.67} r={1.37} />
      <circle className="se-7" cx={450.26} cy={248.77} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={281.99} cy={344.28} r={1.37} />
      <circle className="se-7" cx={280.55} cy={347.58} r={1.37} />
      <circle className="se-7" cx={277.09} cy={348.33} r={1.37} />
      <circle className="se-7" cx={277.78} cy={344.23} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={261.76} cy={367.91} r={1.37} />
      <circle className="se-7" cx={262.45} cy={364.38} r={1.37} />
      <circle className="se-7" cx={265.67} cy={362.9} r={1.37} />
      <circle className="se-7" cx={265.89} cy={367.04} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={243.18} cy={355.91} r={1.37} />
      <circle className="se-7" cx={240.76} cy={353.24} r={1.37} />
      <circle className="se-7" cx={241.49} cy={349.77} r={1.37} />
      <circle className="se-7" cx={244.95} cy={352.08} r={2.64} />
    </g>
    <g>
      <circle className="se-7" cx={244.97} cy={367.24} r={1.37} />
      <circle className="se-7" cx={248.46} cy={368.12} r={1.37} />
      <circle className="se-7" cx={249.78} cy={371.41} r={1.37} />
      <circle className="se-7" cx={245.62} cy={371.41} r={2.64} />
    </g>
  </svg>
);
export { SvgErrorServer };
